var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6673 36C52.6673 45.2048 45.2054 52.6667 36.0007 52.6667C26.7959 52.6667 19.334 45.2048 19.334 36C19.334 26.7953 26.7959 19.3334 36.0007 19.3334C45.2054 19.3334 52.6673 26.7953 52.6673 36ZM31.0007 32.6666H34.1673C34.1673 31.755 34.9228 30.8335 36.0007 30.8335C36.9899 30.8335 37.834 31.4192 37.834 32.6666C37.834 33.67 36.9556 34.4241 36.0789 35.1768L36.023 35.2248C35.2018 35.9291 34.3383 36.6696 34.3383 38.0573C34.3383 39.1191 34.3359 39.3064 34.3347 39.3334H37.6673V38.4144C37.6673 37.5644 38.3569 36.9845 38.9519 36.4841C39.0371 36.4125 39.1204 36.3425 39.1994 36.2735C40.0778 35.5071 41.0007 34.2063 41.0007 32.6666C41.0007 29.9336 39.2211 27.6602 36.0263 27.6602C32.5253 27.6602 31.0007 30.6087 31.0007 32.6666ZM37.8346 42.8223C37.8286 41.8149 37.0101 41 36.0013 41C34.9925 41 34.174 41.8149 34.168 42.8223L34.168 42.8112V42.8334L34.168 42.8223C34.174 43.8297 34.9925 44.6446 36.0013 44.6446C37.0101 44.6446 37.8286 43.8297 37.8346 42.8223ZM37.8346 42.8223L37.8346 42.8112V42.8334L37.8346 42.8223Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBig);
export default __webpack_public_path__ + "static/media/question-big.7eca2f46b459603490151fcb408a8f96.svg";
export { ForwardRef as ReactComponent };